(function () {
  function setupCard(cardWrapper) {
    if (cardWrapper.dataset.jvHoverReady) return;

    var media = cardWrapper.querySelector('.card__media');
    var quickAdd = cardWrapper.querySelector('.quick-add');
    var link = cardWrapper.querySelector('.card__heading a.full-unstyled-link');
    if (!media || !quickAdd || !link) return;

    cardWrapper.dataset.jvHoverReady = 'true';

    var overlayBar = document.createElement('div');
    overlayBar.className = 'jv-card-overlay';

    // Relocate the existing quick-add control (modal-opener + quick-add-modal,
    // or the add-to-cart form for single-variant products) into the image
    // overlay, without touching its contents — this preserves Dawn's native
    // quick-add popup / add-to-cart behavior.
    overlayBar.appendChild(quickAdd);

    media.appendChild(overlayBar);
  }

  function setupAll(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(setupCard);
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });
})();
